export default class RatingBindings {
    constructor(rating) {
        this.rating = rating;

        this.initBindings();
    }

    initBindings() {

        $(this.rating.$selector).find('li').hover((e) => {
            let $target = $(e.target);
            $target.prevAll().addBack().addClass(this.rating.settings.hoverClass);
        }, (e) => {
            let $target = $(e.target);
            $target.prevAll().addBack().removeClass(this.rating.settings.hoverClass);
        });

        $(this.rating.$selector).find('li').on('click', (e) => {
            let $target = $(e.target),
                $parent = $target.parent(),
                $field = $parent.find(`.${this.rating.field}`);

            if ($parent.hasClass('rating-set')) {
                return;
            }

            $parent.find('li').removeClass(this.rating.settings.activeClass);

            $target.prevAll().addBack().addClass(this.rating.settings.activeClass);

            $field.val($target.index() + 1);
            $field.removeAttr('data-rating-dirt');
            $field.closest('.rate-feature').find('.rate-feature__error').hide();

            $.request('SiteSettings::onAddRatingValue', {
                'data': {'rating': $target.attr('data-rating')},
                'update': {'jade-star-rating': '.footer-raiting'}
            });

            //to complete
            $parent.addClass('rating-set');
        });
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/star-rating-static/RatingBindings.js